<div class="supply-dispatch-page mat-elevation-z2">
  <div class="header">
    <h2>Supply Dispatch</h2>
    <button mat-stroked-button (click)="resetForm()">Reset Form</button>
  </div>

  <mat-progress-bar *ngIf="loading || saving" mode="indeterminate"></mat-progress-bar>

  <div class="entry-card">
    <h3>{{ editingId ? 'Edit Dispatch Entry' : 'New Dispatch Entry' }}</h3>
    <div class="form-grid">
      <mat-form-field appearance="outline">
        <mat-label>Product Type</mat-label>
        <mat-select [(value)]="form.productTypeId" (selectionChange)="onTypeChange()">
          <mat-option [value]="null">Select Type</mat-option>
          <mat-option *ngFor="let t of productTypes" [value]="t.id">{{ t.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Item Type</mat-label>
        <mat-select [(value)]="form.productItemId">
          <mat-option [value]="null">Select Item</mat-option>
          <mat-option *ngFor="let i of productItems" [value]="i.id">{{ i.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Buyer Name</mat-label>
        <input matInput [(ngModel)]="form.buyerName" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Buyer Contact</mat-label>
        <input matInput [(ngModel)]="form.buyerContact" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Origin</mat-label>
        <input matInput [(ngModel)]="form.origin" placeholder="From location" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Destination</mat-label>
        <input matInput [(ngModel)]="form.destination" placeholder="To buyer location" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Units Out</mat-label>
        <input matInput type="number" min="0.01" step="0.01" [(ngModel)]="form.unitCount" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Unit Price</mat-label>
        <input matInput type="number" min="0.01" step="0.01" [(ngModel)]="form.unitPrice" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Commission (%)</mat-label>
        <input matInput type="number" min="0" max="100" step="0.01" [(ngModel)]="form.commissionRate" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Dispatch Date</mat-label>
        <input matInput type="date" [(ngModel)]="form.dispatchDate" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="notes-field">
      <mat-label>Notes</mat-label>
      <textarea matInput rows="2" [(ngModel)]="form.notes"></textarea>
    </mat-form-field>

    <div class="amount-preview">
      <div><span>Gross Amount</span><strong>₦{{ totalAmount | number:'1.2-2' }}</strong></div>
      <div><span>Commission</span><strong>₦{{ commissionAmount | number:'1.2-2' }}</strong></div>
      <div><span>Net Amount</span><strong>₦{{ netAmount | number:'1.2-2' }}</strong></div>
    </div>

    <div class="actions">
      <button mat-flat-button color="primary" (click)="saveDispatch()" [disabled]="saving">
        {{ editingId ? 'Update Dispatch' : 'Save Dispatch' }}
      </button>
    </div>
  </div>

  <div class="table-card">
    <h3>Recent Dispatch Entries</h3>
    <table mat-table [dataSource]="dispatchRows" class="full-table mat-elevation-z1">
      <ng-container matColumnDef="dispatchDate">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let row">{{ row.dispatchDate | date:'mediumDate' }}</td>
      </ng-container>

      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef>Product</th>
        <td mat-cell *matCellDef="let row">{{ row.productTypeName }} / {{ row.productItemName }}</td>
      </ng-container>

      <ng-container matColumnDef="buyer">
        <th mat-header-cell *matHeaderCellDef>Buyer</th>
        <td mat-cell *matCellDef="let row">
          <div>{{ row.buyerName }}</div>
          <small>{{ row.buyerContact || '-' }}</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="route">
        <th mat-header-cell *matHeaderCellDef>Route</th>
        <td mat-cell *matCellDef="let row">{{ row.origin || '-' }} → {{ row.destination || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="units">
        <th mat-header-cell *matHeaderCellDef>Units</th>
        <td mat-cell *matCellDef="let row">{{ row.unitCount | number:'1.2-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="pricing">
        <th mat-header-cell *matHeaderCellDef>Unit Price / Comm.</th>
        <td mat-cell *matCellDef="let row">
          <div>₦{{ row.unitPrice | number:'1.2-2' }}</div>
          <small>{{ row.commissionRate | number:'1.0-2' }}%</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="totalAmount">
        <th mat-header-cell *matHeaderCellDef>Total / Net</th>
        <td mat-cell *matCellDef="let row">
          <div>₦{{ row.totalAmount | number:'1.2-2' }}</div>
          <small>Net ₦{{ (row.totalAmount - row.commissionAmount) | number:'1.2-2' }}</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="dispatchMenu">
            <mat-icon>menu</mat-icon>
          </button>
          <mat-menu #dispatchMenu="matMenu">
            <button mat-menu-item (click)="editRow(row)">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button mat-menu-item (click)="deleteRow(row)">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
